module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/fonts/fontawesome-webfont.ttf?v=4.1.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.ttf?v=4.1.0
// module chunks = styles